import { AppImage, Typography } from '@/app/common';
import { cn, getBackgroundClass } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';
import { processHeading } from '@workspace/lib/heading-utils';
import { QuoteBlockData } from './quote.types';

const resolveQuoteIconSrc = (icon?: QuoteBlockData['icon'], bynderIcon?: QuoteBlockData['bynderIcon']) => {
  return (
    bynderIcon?.selectedUrl ||
    bynderIcon?.datUrl ||
    bynderIcon?.previewUrl ||
    bynderIcon?.previewImg ||
    bynderIcon?.url ||
    icon?.url ||
    icon?.asset?.url ||
    ''
  );
};

export function QuoteBlock({
  backgroundColor,
  heading,
  icon,
  bynderIcon,
  subheading,
  textAlignment = 'middle',
}: QuoteBlockData) {
  const { text } = processHeading(heading);
  const backgroundClass = getBackgroundClass(backgroundColor);
  const iconSrc = resolveQuoteIconSrc(icon, bynderIcon);

  const alignmentValue = stripInvisibles(textAlignment || '')
    .trim()
    .toLowerCase();
  const alignmentClass = {
    left: 'text-left',
    middle: 'text-center',
    center: 'text-center',
    right: 'text-right',
  }[alignmentValue];

  return (
    <section className={cn('w-full', backgroundClass)}>
      <div className="porta-container md:px-md-banner md:py-16 py-xl px-6">
        <div
          className={cn(
            'flex flex-col',
            'md:gap-lg md:text-4xl gap-sm text-2xl',
            textAlignment === 'left' && 'items-start',
            textAlignment === 'middle' && 'items-center',
            textAlignment === 'right' && 'items-end',
          )}
        >
          {iconSrc && (
            <div className="icon-container flex justify-center">
              <AppImage alt={icon?.alt || ''} src={iconSrc} width={48} height={48} />
            </div>
          )}

          <div className="content-container flex flex-col md:gap-md gap-sm">
            {text && (
              <Typography
                variant="h2"
                styleVariant="h3"
                className={cn('text-secondary-400! text-2xl! md:text-4xl!', alignmentClass)}
              >
                {text}
              </Typography>
            )}

            {subheading && (
              <Typography variant="h6" className={cn('text-primary!', alignmentClass)}>
                {subheading}
              </Typography>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
